import { render, staticRenderFns } from "./TopProductsChart.vue?vue&type=template&id=1ef01d04&scoped=true&"
import script from "./TopProductsChart.vue?vue&type=script&lang=js&"
export * from "./TopProductsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef01d04",
  null
  
)

export default component.exports